import React from 'react';
import { get } from 'lodash';
import className from 'classnames';

export const BounceEmailBadge = ({status}) => {

  const reputationStatus = (status) => {
    switch (status) {
      case "Permanent": return "bounce"
      case "Transient": return "warning"
      default: return "normal"
    }
  }

  const reputationToolTip = (status) => {
    switch (status) {
      case "bounce": return "Permanent email bounce. Email cannot be sent again"
      case "warning": return "General email bounce. Email might be able to send again in the future"
      case "normal": return "Email can be sent normally"
    }
  }

  const formattedStatus = reputationStatus(status)

  return (
    <span className={className("Badge Badge--with-tooltip",{
        "Badge--yellow": formattedStatus === 'warning',
        "Badge--red": formattedStatus === 'bounce'
      })}
    >
      {formattedStatus}
      <span className="Badge__tooltip">{reputationToolTip(formattedStatus)}</span>
    </span>
  )
}

export default BounceEmailBadge;
